// extracted by mini-css-extract-plugin
export default {"switchContainer":"ToggleSwitch_switchContainer__CAFC8","switchLabel":"ToggleSwitch_switchLabel__ZwCD8","switch":"ToggleSwitch_switch__A8vg6","slider":"ToggleSwitch_slider__++DKZ"};